import React from 'react'
import '../styles/ToggleSwitch.css'

const ToggleSwitch = ({ input, label, meta: { touched, error } }) => {
  return (
    <div className="toggle-switch-container">
      <label className="toggle-switch-label">{label}</label>
      <div className="toggle-switch-wrapper">
        <label className="toggle-switch">
          <input
            type="checkbox"
            checked={input.value}
            onChange={input.onChange}
          />
          <span className="toggle-slider">
            <span className="toggle-text-no">NO</span>
            <span className="toggle-text-si">SÍ</span>
          </span>
        </label>
      </div>
      {touched && error && <span className="text-danger">{error}</span>}
    </div>
  )
}

export default ToggleSwitch
